import { styled, TableCell } from '@mui/material';

const BorderlessTableCell = styled(TableCell)({
    borderBottom: 0,
});

export { BorderlessTableCell };
